import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({
  name: 'appShopLogoUrl',
  standalone: true,
})
export class ShopLogoUrlPipe implements PipeTransform {
  public transform(shopId: string): string {
    return `${environment.backendBaseUrl}/shops/${shopId}/logo`;
  }
}
